import api from './api';

export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/admin/upload/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to upload file');
  }
};

export const deleteFile = async (fileId) => {
  try {
    const response = await api.delete(`/admin/upload/${fileId}/delete/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to delete file');
  }
};

export const listFiles = async () => {
  try {
    const response = await api.get('/admin/upload/list/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to list files');
  }
};


